import inicialState from './microscopia.state';
import * as actions from './microscopia.action';

const microscopiaReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.MICROSCOPIA_FINALIZADA:
      return {
        ...state,
        microscopiaFinalizada: action.payload.microscopiaFinalizada,
      };  
    default:
      return state;
  }
};

export default microscopiaReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/microscopia/microscopia.reducer.js